import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const ProjectPageWrapper = styled.div`
  width: 100%;
  .ad-card {
    margin: 32px 0;
    display: none;
    @media (${mediaQuery.mobile}) {
      display: flex;
    }
  }
`;

export const InnerPageWrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding: 24px 0 0;
  @media (${mediaQuery.mobile}) {
    padding: 16px 0 0;
  }
`;

export const LeftContainerWrapper = styled.div`
  width: 100%;
  float: left;
  @media (${mediaQuery.tablet}) {
    width: 100%;
    float: none;
  }
  @media (max-width: 768px) {
    margin-top: 120px;
  }
`;

export const LeftContainer = styled.div`
  margin-right: 390px;
  @media (${mediaQuery.tablet}) {
    margin: 0;
  }
`;

export const AsideContainer = styled.div`
  float: right;
  width: 300px;
  margin-left: -360px;
  @media (${mediaQuery.tablet}) {
    display: none;
  }
`;

export const ProjectPageLeadsCaptureWrapper = styled.div`
  padding: 24px;
  margin-top: 10px;
  margin-bottom: 24px;
  border: 1px solid #d2d5da;
  border-radius: 3px;
  @media (${mediaQuery.tablet}) {
    border-radius: 0px;
    margin-left: 24px;
    margin-right: 24px;
  }
  @media (${mediaQuery.mobile}) {
    padding: 24px 16px 32px 16px;
    border-left: 0px;
    border-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const DisclaimerContainer = styled.div`
  margin: 17px auto 24px auto;
  max-width: 1140px;
  @media (${mediaQuery.tablet}) {
    padding: 0 24px;
  }

  @media (${mediaQuery.mobile}) {
    padding: 0 16px;
  }
`;

export const Divider = styled.hr`
  clear: both;
  width: 100%;
  margin: 0;
  height: 1px;
  background-color: #d2d6da;
  border: none;
  @media (${mediaQuery.tablet}) {
    width: auto;
    margin: 0 24px;
  }
  ${media.xs`
    margin: 0;
  `}
  &.recommended-divider {
    ${media.xs`
      margin: 0 16px;;
    `}
  }
`;
